/*
pango-cze.js
Este fichero se llama en theme.liquid
*/
//————————————————————————————————————————————————————————————————————————————————
//                                 VARIABLES
//————————————————————————————————————————————————————————————————————————————————
// MODAL
let pModal;

// VARIABLES
let datosParaSession = {
  cartHasPlus24hProduct:null,
  cartHasPrep72h:null,
  recogidaEnTienda:null,
  entregaFueraM50: null,
  savedAt:null,
};

//————————————————————————————————————————————————————————————————————————————————
// CADA CAMBIO DE CARRITO
// en cart.js --> onChange/updateQuantity --> document.dispatchEvent(new Event('pangoCartChange'));
// en cart-drawer.liquid : en cada card de producto si es prep_mas_24h añadimos attributo pango-prep_mas_24h.
// si el carrito no está vacio, comprueba si hay +24h products buscando el attributo, actualiza localStorage.
//————————————————————————————————————————————————————————————————————————————————
document.addEventListener('pangoCartChange', () => {
  setTimeout(() => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateDatosCartHasPlus24hProduct(cart));
  }, 1000);
});

function updateDatosCartHasPlus24hProduct(cart) {
  //console.log("updateDatosCartHasPlus24hProduct", cart);
  if (!cart || !cart.items || cart.items.length === 0) {
    return false;
  }
  guardaCartHasPlus24hProduct();
}

// mira si el carrito pintado (lateral o página /cart) tiene algún producto +24h y lo guarda en localStorage
function guardaCartHasPlus24hProduct() {
  const prep_mas_24hElement = document.querySelector('[pango-prep_mas_24h]');
  const prep_mas_24h = !!prep_mas_24hElement;
  let czeSessionDataUpdate = {};
  try {
    const raw = localStorage.getItem('czeSessionData');
    if (raw) {
      czeSessionDataUpdate = JSON.parse(raw);
    }
  } catch (e) {
    console.warn("Error parseando czeSessionData", e);
  }

  czeSessionDataUpdate.cartHasPlus24hProduct = prep_mas_24h;
  czeSessionDataUpdate.cartHasPrep72h = !!document.querySelector('[pango-prep_72h]');
  localStorage.setItem( 'czeSessionData', JSON.stringify(czeSessionDataUpdate));
}
//————————————————————————————————————————————————————————————————————————————————
//                                 MODAL ENTREGA
//————————————————————————————————————————————————————————————————————————————————
//================================================= 
// ABRE FORM SI 
// - no hay datos guardados
// - se han guardado datos más de XX horas
//=================================================
function checkIfOpenEntregaForm() {
  // antes se guardaba en sessionStorage (solo esa pestaña): se pasa a localStorage para no volver a preguntar
  if (!localStorage.getItem('czeSessionData') && sessionStorage.getItem('czeSessionData')) {
    localStorage.setItem('czeSessionData', sessionStorage.getItem('czeSessionData'));
  }
  const czeSessionDataRaw = localStorage.getItem('czeSessionData');

  if (!czeSessionDataRaw) {
      // si en esta sesión ya se cerró sin elegir, no se vuelve a abrir en cada página (al pagar se pregunta igualmente)
      if (!sessionStorage.getItem('czeCerradoSinElegir')) openEntregaForm()
      return;
  }
  
  try {        
      const czeSessionData = JSON.parse(czeSessionDataRaw);
      const savedAt = czeSessionData.savedAt;

      const HOURS = 30 * 24 // la zona se recuerda 30 días entre visitas y pestañas
      const HOURS_LIMIT = HOURS * 60 * 60 * 1000;
      const isOlderThanHoursLimit = !savedAt || (Date.now() - savedAt > HOURS_LIMIT);

      if (isOlderThanHoursLimit) {
      console.log("borrando sessionstorage")
      localStorage.removeItem('czeSessionData');
      openEntregaForm()
      }
  } catch (error) {
      console.log("borrando sessionstorage")
      localStorage.removeItem('czeSessionData');
      openEntregaForm()
  }
}

//================================================= 
// ELEMENT <MAIN> ATTRIBUTE
// se lanza al finalizar form y siempre al cargar pagina 
// utilizamos este atributo para ocultar cards con css
//================================================= 
function setUserentregaFueraM50Attribute(){
  let mainElement = document.querySelector('main')
  if (!mainElement) return;

  const czeSessionDataRaw = localStorage.getItem('czeSessionData');
  if (!czeSessionDataRaw) return;

  const czeSessionData = JSON.parse(czeSessionDataRaw);
  console.log("czeSessionData", czeSessionData)
  if(czeSessionData.entregaFueraM50){
      mainElement.dataset.czeUserSeleccionadoEnvioFueraM50="true"  
  } else {
      mainElement.dataset.czeUserSeleccionadoEnvioFueraM50="false"
  }
}

//================================================= 
// OPEN ENTREGA FORM desde BTN
//================================================= 
function openEntregaFormBtn(){
  // no se borra la zona guardada: si el cliente cierra sin elegir, se queda con la que tenía
  openEntregaForm()
}

//================================================= 
// OPEN ENTREGA FORM
// desdeCheckout: se abre desde "Finalizar la compra" porque no había zona elegida
//================================================= 
function openEntregaForm(desdeCheckout){
  // al entrar en la web: bienvenida, enlace a Glovo y nota; al ir a pagar: otra cabecera y solo los botones
  pModal.querySelectorAll('[data-solo-bienvenida]').forEach(el => el.hidden = !!desdeCheckout);
  pModal.querySelectorAll('[data-solo-pago]').forEach(el => el.hidden = !desdeCheckout);
  pModal.showModal();

  // ZONA DE ENTREGA: una sola pregunta, guarda lo mismo que el form antiguo de 3 pasos
  // - dentro-m50 : envío a domicilio dentro M50 → recogidaEnTienda=false, entregaFueraM50=false
  // - recogida   : recogida en tienda           → recogidaEnTienda=true,  entregaFueraM50=false
  // - fuera-m50  : envío al resto de España     → recogidaEnTienda=false, entregaFueraM50=true
  // onclick (no addEventListener) para no duplicar el evento si se abre el form varias veces
  const zonaButtons = pModal.querySelectorAll('[data-cze-zona]');
  zonaButtons.forEach(btn => {
    btn.onclick = async function () {
      const fueraM50 = btn.dataset.czeZona === "fuera-m50";
      // el carrito solo se vacía si hace falta: envío fuera de la M50 con algún producto que no se envía,
      // y avisando antes (si el cliente cancela, sigue en el pop-up y puede elegir otra opción)
      const hayQueVaciar = fueraM50 && await carritoTieneNoAptosFueraM50();
      if (hayQueVaciar && !confirm(pModal.dataset.avisoVaciarCarrito)) return;
      datosParaSession.recogidaEnTienda = btn.dataset.czeZona === "recogida";
      datosParaSession.entregaFueraM50 = fueraM50;
      datosParaSession.savedAt = Date.now();
      guardaEnSession();
      pModal.close();
      if (hayQueVaciar) {
        vaciaCarrito();
      } else if (desdeCheckout) {
        openCalendarModal();
      }
    };
  });

}

//================================================= 
// ¿HAY EN EL CARRITO PRODUCTOS QUE NO SE ENVÍAN FUERA DE LA M50?
// se pide el carrito lateral al servidor (puede haber cambiado en otra pestaña);
// en cart-drawer.liquid cada producto lleva data-apto-para-envio-fuera-M50
//================================================= 
async function carritoTieneNoAptosFueraM50(){
  try {
    const html = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return !!doc.querySelector('.cart-item:not([data-apto-para-envio-fuera-m50="true"])');
  } catch (e) {
    // si no se puede comprobar, como antes: vaciar (avisando)
    return true;
  }
}

//================================================= 
// GUARDA EN SESSION
//================================================= 
function guardaEnSession(){
    localStorage.removeItem('czeSessionData');
    localStorage.setItem('czeSessionData', JSON.stringify(datosParaSession));
    setUserentregaFueraM50Attribute()  
    logDatosSessionStorage()
}
  
//================================================= 
// START
//================================================= 
function initPango() {
  pModal = document.getElementById('czeFirstForm');
  console.log("pModal", pModal);
  
  if (!pModal) {
    console.warn("Modal no encontrado");
    return;
  }

  // cerrado sin elegir (botón de cerrar, Esc o "atrás" en el móvil): se recuerda durante la sesión
  pModal.addEventListener('close', () => {
    if (!tieneZonaElegida()) sessionStorage.setItem('czeCerradoSinElegir', '1');
  });

  checkIfOpenEntregaForm();
  setUserentregaFueraM50Attribute();
}

// Si el DOM ya está listo, ejecutar directamente
// Si no, esperar al evento
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initPango);
} else {
  initPango();  
}
 

//————————————————————————————————————————————————————————————————————————————————
//                                 CALENDARIO
//————————————————————————————————————————————————————————————————————————————————
//================================================= 
// ¿HAY ZONA ELEGIDA?
// el calendario necesita saber si es recogida y si es fuera M50
//================================================= 
function tieneZonaElegida(){
  try {
    const czeSessionData = JSON.parse(localStorage.getItem('czeSessionData'));
    return !!czeSessionData
      && typeof czeSessionData.recogidaEnTienda === 'boolean'
      && typeof czeSessionData.entregaFueraM50 === 'boolean';
  } catch (e) {
    return false;
  }
}

//================================================= 
// OPEN/CLOSE MODAL CALENDAR
//================================================= 
function openCalendarModal(){
    // sin zona elegida (pop-up cerrado con Esc o con "atrás" en el móvil) el calendario
    // no puede calcular fechas y se queda vacío: primero se pregunta la zona
    if (!tieneZonaElegida()) {
      openEntregaForm(true);
      return;
    }
    // recalcula +24h antes de pintar el calendario: Globo (opciones con precio) añade al carrito
    // sin pasar por cart.js, así que pangoCartChange no salta
    guardaCartHasPlus24hProduct();
    const pCalendar = document.getElementById('pCalendar');
    pCalendar.showModal();
    // envío a domicilio dentro de la M-50: aviso de que al pagar hay que elegir «Entrega local» (no el envío nacional)
    const avisoEntregaLocal = document.getElementById('czeAvisoEntregaLocal');
    if (avisoEntregaLocal) {
      const zona = JSON.parse(localStorage.getItem('czeSessionData'));
      avisoEntregaLocal.hidden = !(zona.recogidaEnTienda === false && zona.entregaFueraM50 === false);
    }
    initCalendarYcheckoutBtn();
}
function closeCalendar(){
    const pCalendar = document.getElementById('pCalendar');
    pCalendar.close();
}

//================================================= 
// CHECKOUT BUTTON
//================================================= 
function initCalendarYcheckoutBtn() {  
  
  initCzeCalendar()
 
  // checkout button 
  const calendarCheckoutBtn = document.getElementById('calendarCheckoutBtn');
  if (!calendarCheckoutBtn) return;
  addDeliveryDateToOrderAndCheckOut()
}

//================================================= 
// CHECKOUT BUTTON
//================================================= 
function addDeliveryDateToOrderAndCheckOut(){
  
  calendarCheckoutBtn.addEventListener('click', async () => {
    let selectedDate = 'not selected';
    const selectedDeliveryDateElement = document.querySelector('[data-selected-delivery-date]');
    if (selectedDeliveryDateElement && selectedDeliveryDateElement.dataset.selectedDeliveryDate) {
      selectedDate = selectedDeliveryDateElement.dataset.selectedDeliveryDate;
      console.log("selectedDeliveryDateElement", selectedDate)
    }

    try {
      // add delivery date to cart attribute
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            delivery_date: selectedDate
          }
        })
      });

      const cart = await fetch('/cart.js').then(r => r.json());
      console.log('delivery_date :', cart.attributes?.delivery_date);
      
      // go to checkout
      document.getElementById('CartDrawer-Checkout')?.click();

    } catch (error) {
      console.error('Error en checkout flow:', error);
    }
  });
}

//————————————————————————————————————————————————————————————————————————————————
//                                 MENOS RELEVANTES
//————————————————————————————————————————————————————————————————————————————————
//================================================= 
// VACIA CARRITO 
// se lanza cuando se abre el form
//================================================= 
function vaciaCarrito() {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        if (!cart.items || cart.items.length === 0) {
            console.log('Carrito ya vacío');
            return;
        }

        return fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            }
        });
    })
    .then(response => {
        if (!response) return; // no había items

        if (!response.ok) throw new Error('Error clearing cart');
            return response.json();
        })
    .then(data => {
        if (!data) return;

        console.log('Carrito vaciado', data);
        window.location.reload();
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

//================================================= 
// log datos session storage
//================================================= 
function logDatosSessionStorage(){
    const czeSessionDataRaw = localStorage.getItem('czeSessionData');
    if (!czeSessionDataRaw) return;
    const czeSessionData = JSON.parse(czeSessionDataRaw);
    console.log("session",czeSessionData)
}